module.exports = __webpack_public_path__ + "media/images/undraw/web_search-30fa149a83d80cb34f5b8cd652e661e3.png";